var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('default-count-card',{staticStyle:{"height":"100%"},attrs:{"flag":_vm.flag,"title_with_icon":false,"value":_vm.data,"title":_vm.title,"title_class":_vm.title_class,"not_rounded":""},scopedSlots:_vm._u([{key:"extra",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }